
import type { PropType } from 'vue'
import type Vue from 'vue'
import { useDark } from '@vueuse/core'
import { defineComponent, getCurrentInstance } from 'vue'
import LoginForm from './login-form.component.vue'

export interface LoginEvent {
  startDate: Date
  endDate: Date
  resources: {
    video?: string
    poster?: string
    image?: string
    icon?: string
  }
  name: string
  location: {
    name: string
    surname: string
  }
}

export default defineComponent({
  name: 'Login',
  components: {
    LoginForm,
  },
  props: {
    scheduledEvents: {
      type: Array as PropType<Array<LoginEvent>>,
      default: () => [],
    },
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }
    useDark({
      selector: 'html',
      attribute: 'data-theme',
    })

    return {}
  },
  computed: {
    activeEvent(): LoginEvent {
      return this.scheduledEvents.find(
        event => event.startDate <= new Date() && event.endDate > new Date(),
      )
    },
  },
  methods: {
    onLogin(success: boolean) {
      this.$emit('login', success)
    },
  },
})
